export default {
  setNotificationsList(state, payload) {
    state.notifications.notificationsList = payload;
  },
};
